import { createHomePageContentPlaceholder } from './createHomePageContentPlaceholder';
import { createFooterContentPlaceholder } from './createFooterContentPlaceholder';
import { createApplicationsContentPlaceholder } from './createApplicationsContentPlaceholder';
import { createAboutInvestorRelationsPlaceholder } from './createAboutInvestorRelationsContentPlaceholder';
import type { ContentTree } from '../types/SiteContentElement';
import { createAboutYageoGroupOverviewContentPlaceholder } from './createAboutYageoGroupOverviewContentPlaceholder';
import { createAboutCareersContentPlaceholder } from './createAboutCareersContentPlaceholder';
import { createAboutSustainabilityContentPlaceholder } from './createAboutSustainabilityContentPlaceholder';
import { createAboutNewsroomContentPlaceholder } from './createAboutNewsroomContentPlaceholder';
import { createSalesAndResourcesContactPointsContentPlaceholder } from './createSalesAndResourcesContactPointsContentPlaceholder';
import { createSalesAndResourcesResourceLibraryContentPlaceholder } from './createSalesAndResourcesResourceLibraryContentPlaceholder';
import { createCommonContentPlaceholder } from './createCommonContentPlaceholder';
import { createProductsContentPlaceholder } from './createProductsContentPlaceholder';
import type { SiteContentPath } from '../types/siteContentPaths';
import { createSalesAndResourcesSensorAcademyContentPlaceholder } from './createSalesAndResourcesSensorAcademyPlaceholder';
import { createSalesAndResourcesSimulationToolsContentPlaceholder } from './createSalesAndResourcesSimulationToolsPlaceholder';
import { createSalesAndResourcesDistributorPortalsContentPlaceholder } from './createSalesAndResourcesDistributorPortalsPlaceholder';

/**
 * Provides placeholder content for various site paths before actual content is loaded from Pimcore.
 * Additional, the retrieved content is verified against these placeholders and merged with them on
 * error to ensure expected structure is returned so that TypeScript types can be used effectively
 * and frontend does not blow up completely on missing data or invalid data retrieved from Pimcore.
 */
const siteContentPlaceholders: Record<SiteContentPath, unknown> = {
    '/_common': createCommonContentPlaceholder(),
    '/HomePage': createHomePageContentPlaceholder(),
    '/Footer': createFooterContentPlaceholder(),
    '/Products': createProductsContentPlaceholder(),
    '/Applications': createApplicationsContentPlaceholder(),
    '/About/Careers': createAboutCareersContentPlaceholder(),
    '/About/InvestorRelations': createAboutInvestorRelationsPlaceholder(),
    '/About/Newsroom': createAboutNewsroomContentPlaceholder(),
    '/About/Sustainability': createAboutSustainabilityContentPlaceholder(),
    '/About/YageoGroupOverview': createAboutYageoGroupOverviewContentPlaceholder(),
    '/SalesAndResources/ContactPoints': createSalesAndResourcesContactPointsContentPlaceholder(),
    '/SalesAndResources/ResourceLibrary':
        createSalesAndResourcesResourceLibraryContentPlaceholder(),
    '/SalesAndResources/SensorAcademy': createSalesAndResourcesSensorAcademyContentPlaceholder(),
    '/SalesAndResources/SimulationTools':
        createSalesAndResourcesSimulationToolsContentPlaceholder(),
    '/SalesAndResources/DistributorPortals':
        createSalesAndResourcesDistributorPortalsContentPlaceholder(),
};

export const getSiteContentPlaceholder = (path: SiteContentPath): ContentTree => {
    const placeholder: ContentTree = siteContentPlaceholders[
        path as SiteContentPath
    ] as unknown as ContentTree;
    if (!placeholder || Object.keys(placeholder).length === 0) {
        console.error(`No placeholder content found for path: ${path}`);
        return {};
    }
    return placeholder;
};
